import { render, staticRenderFns } from "./EmpresaEdit.vue?vue&type=template&id=454c5b36&scoped=true&"
import script from "./EmpresaEdit.vue?vue&type=script&lang=js&"
export * from "./EmpresaEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaEdit.vue?vue&type=style&index=0&id=454c5b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454c5b36",
  null
  
)

export default component.exports